import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Matricula.css";
import { FaEye } from "react-icons/fa";

//  Imágenes 
import docentesImg from "../assets/servicios/intranet/docente.jpg";
import alumnosImg from "../assets/servicios/intranet/alumno.jpg";
import administrativoImg from "../assets/servicios/intranet/administrativo.jpg";

const Intranet = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const items = [
    {
      titulo: "Docentes",
     img: docentesImg,
      enlace: "https://iestpjva.jedu.pe/docente/entrar",
    },
    {
      titulo: "Alumnos",
      img: alumnosImg,
      enlace: "https://iestpjva.jedu.pe/alumno/entrar",
    },
    {
      titulo: "Administrativo",
      img: administrativoImg,
      enlace: "https://iestpjva.jedu.pe/admin/entrar",
    },
  ];

  return (
    <section className="matricula-page">
      {/*  Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Intranet</h1>
          
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5 text-center">
        <h2 className="section-subtitle mb-4" data-aos="fade-up">
          Accede al beneficio de tu plataforma virtual
        </h2>
        <p className="lead">
            En el podrás tener tus horarios de clases, tus docentes, notas, etc. 
            Para contar con este beneficio solo debes tener en cuenta los siguientes puntos.
          </p>

        <div className="row g-4 justify-content-center">
          {items.map((item, i) => (
            <div key={i} className="col-lg-3 col-md-6 col-sm-12" data-aos="zoom-in">
              <div className="bolsa-card">
                <div className="bolsa-img-container">
                  <img src={item.img} alt={item.titulo} className="bolsa-img" />
                </div>
                <h5 className="mt-3 fw-bold text-primary">{item.titulo}</h5>
                <p className="mt-2" style={{ fontSize: "0.9rem", color: "#333" }}>
                  {item.descripcion}
                </p>
                <a
                  href={item.enlace}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-descargar mt-2 d-inline-flex align-items-center gap-2"
                >
                  <FaEye size={18} />
                   ver
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Intranet;
